/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the hook used to retrieve the Theme Manager Context.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/**
 * Enables the use of grade data loaded from the ServiceStack API.
 */
import { SubtermsAndGradesSelectors, useSubtermsAndGradesSelector } from 'src/store/reducers/subtermsAndGrades';

/**
 * Typings
 */
import * as Dtos from '../api/dtos';

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const useSubtermsAndGradesIndividualTerm = (
    categoryId: number | null,
    termId: number,
    subtermId: number | null
): [
    Dtos.Term | null
] => {
    const term = useSubtermsAndGradesSelector(state => subtermId ? SubtermsAndGradesSelectors.selectTermFromView(state, termId, subtermId) : null);

    return [
        term
    ];
};

/*
 * ---------------------------------------------------------------------------------
 * Exports - Default
 * ---------------------------------------------------------------------------------
 */

export default useSubtermsAndGradesIndividualTerm;


// WEBPACK FOOTER //
// ./src/hooks/useSubtermsAndGradesIndividualTerm.ts